import * as api from '../api/mineralImport';
import { createRequestTypes, START, SUCCESS, ERROR } from './global';
import { makeApiActionCreatorV3 } from '@actions/utils';

const prefix = 'PROCESS-MANAGER';

export const FETCH_MINERAL_IMPORTS = createRequestTypes(
  `${prefix}/FETCH_MINERAL_IMPORTS`,
);

export const FETCH_MINERAL_IMPORT_TYPES = createRequestTypes(
  `${prefix}/FETCH_MINERAL_IMPORT_TYPES`,
);

export const CREATE_MINERAL_IMPORT_RUN = createRequestTypes(
  `${prefix}/CREATE_MINERAL_IMPORT_RUN`,
);

export const FETCH_MINERAL_IMPORT = createRequestTypes(
  `${prefix}/FETCH_MINERAL_IMPORT`,
);

export const MATCH_MINERAL_IMPORT_RUN = createRequestTypes(
  `${prefix}/MATCH_MINERAL_IMPORT_RUN`,
);

export const IMPORT_MINERAL_IMPORT_RUN = createRequestTypes(
  `${prefix}/IMPORT_MINERAL_IMPORT_RUN`,
);

export const DOWNLOAD_IMPORT_FILE = createRequestTypes(
  `${prefix}/DOWNLOAD_IMPORT_FILE`,
);

export const FETCH_MINERAL_IMPORT_VALIDATION_ERRORS = createRequestTypes(
  `${prefix}/FETCH_MINERAL_IMPORT_VALIDATION_ERRORS`,
);

export const FETCH_MINERAL_IMPORT_VALIDATION_ERROR_DETAILS = createRequestTypes(
  `${prefix}/FETCH_MINERAL_IMPORT_VALIDATION_ERROR_DETAILS`,
);

export const FETCH_MINERAL_IMPORT_MATCHED_PROPERTIES = createRequestTypes(
  `${prefix}/FETCH_MINERAL_IMPORT_MATCHED_PROPERTIES`
);

export const FETCH_MINERAL_IMPORT_MATCHED_AGENTS = createRequestTypes(
  `${prefix}/FETCH_MINERAL_IMPORT_MATCHED_AGENTS`
);

export const FETCH_MINERAL_IMPORT_MATCHED_OWNERS = createRequestTypes(
  `${prefix}/FETCH_MINERAL_IMPORT_MATCHED_OWNERS`
);

export const FETCH_MINERAL_IMPORT_NEW_PROPERTIES = createRequestTypes(
  `${prefix}/FETCH_MINERAL_IMPORT_NEW_PROPERTIES`
);

export const FETCH_MINERAL_IMPORT_NEW_AGENTS = createRequestTypes(
  `${prefix}/FETCH_MINERAL_IMPORT_NEW_AGENTS`
);

export const FETCH_MINERAL_IMPORT_NEW_OWNERS = createRequestTypes(
  `${prefix}/FETCH_MINERAL_IMPORT_NEW_OWNERS`
);

export const FETCH_MINERAL_IMPORT_ERROR_PROPERTIES = createRequestTypes(
  `${prefix}/FETCH_MINERAL_IMPORT_ERROR_PROPERTIES`
);

export const FETCH_MINERAL_IMPORT_ERROR_AGENTS = createRequestTypes(
  `${prefix}/FETCH_MINERAL_IMPORT_ERROR_AGENTS`
);

export const FETCH_MINERAL_IMPORT_ERROR_OWNERS = createRequestTypes(
  `${prefix}/FETCH_MINERAL_IMPORT_ERROR_OWNERS`
);

export const FETCH_MINERAL_IMPORT_MINERAL_DETAILS = createRequestTypes(
  `${prefix}/FETCH_MINERAL_IMPORT_MINERAL_DETAILS`
);

export const FETCH_MINERAL_IMPORT_DELETED_DETAILS = createRequestTypes(
  `${prefix}/FETCH_MINERAL_IMPORT_DELETED_DETAILS`
);

export const fetchMineralImports = makeApiActionCreatorV3(
  api.fetchMineralImports,
  FETCH_MINERAL_IMPORTS[START],
  FETCH_MINERAL_IMPORTS[SUCCESS],
  FETCH_MINERAL_IMPORTS[ERROR],
);

export const fetchMineralImportTypes = makeApiActionCreatorV3(
  api.fetchMineralImportTypes,
  FETCH_MINERAL_IMPORT_TYPES[START],
  FETCH_MINERAL_IMPORT_TYPES[SUCCESS],
  FETCH_MINERAL_IMPORT_TYPES[ERROR],
);

export const createMineralImportRun = makeApiActionCreatorV3(
  api.createMineralImportRun,
  CREATE_MINERAL_IMPORT_RUN[START],
  CREATE_MINERAL_IMPORT_RUN[SUCCESS],
  CREATE_MINERAL_IMPORT_RUN[ERROR],
);

export const fetchMineralImport = makeApiActionCreatorV3(
  api.fetchMineralImport,
  FETCH_MINERAL_IMPORT[START],
  FETCH_MINERAL_IMPORT[SUCCESS],
  FETCH_MINERAL_IMPORT[ERROR],
);

export const matchMineralImportRun = makeApiActionCreatorV3(
  api.matchMineralImportRun,
  MATCH_MINERAL_IMPORT_RUN[START],
  MATCH_MINERAL_IMPORT_RUN[SUCCESS],
  MATCH_MINERAL_IMPORT_RUN[ERROR],
);

export const importMineralImportRun = makeApiActionCreatorV3(
  api.importMineralImportRun,
  IMPORT_MINERAL_IMPORT_RUN[START],
  IMPORT_MINERAL_IMPORT_RUN[SUCCESS],
  IMPORT_MINERAL_IMPORT_RUN[ERROR],
);

export const downloadImportFile = makeApiActionCreatorV3(
  api.downloadImportFile,
  DOWNLOAD_IMPORT_FILE[START],
  DOWNLOAD_IMPORT_FILE[SUCCESS],
  DOWNLOAD_IMPORT_FILE[ERROR],
);

export const fetchMineralImportValidationErrors = makeApiActionCreatorV3(
  api.fetchMineralImportValidationErrors,
  FETCH_MINERAL_IMPORT_VALIDATION_ERRORS[START],
  FETCH_MINERAL_IMPORT_VALIDATION_ERRORS[SUCCESS],
  FETCH_MINERAL_IMPORT_VALIDATION_ERRORS[ERROR],
);

export const fetchMineralImportValidationErrorDetails = makeApiActionCreatorV3(
  api.fetchMineralImportValidationErrorDetails,
  FETCH_MINERAL_IMPORT_VALIDATION_ERROR_DETAILS[START],
  FETCH_MINERAL_IMPORT_VALIDATION_ERROR_DETAILS[SUCCESS],
  FETCH_MINERAL_IMPORT_VALIDATION_ERROR_DETAILS[ERROR],
);

export const fetchMineralImportMatchedProperties = makeApiActionCreatorV3(
  api.fetchMineralImportMatchedProperties,
  FETCH_MINERAL_IMPORT_MATCHED_PROPERTIES[START],
  FETCH_MINERAL_IMPORT_MATCHED_PROPERTIES[SUCCESS],
  FETCH_MINERAL_IMPORT_MATCHED_PROPERTIES[ERROR]
);

export const fetchMineralImportMatchedAgents = makeApiActionCreatorV3(
  api.fetchMineralImportMatchedAgents,
  FETCH_MINERAL_IMPORT_MATCHED_AGENTS[START],
  FETCH_MINERAL_IMPORT_MATCHED_AGENTS[SUCCESS],
  FETCH_MINERAL_IMPORT_MATCHED_AGENTS[ERROR]
);

export const fetchMineralImportMatchedOwners = makeApiActionCreatorV3(
  api.fetchMineralImportMatchedOwners,
  FETCH_MINERAL_IMPORT_MATCHED_OWNERS[START],
  FETCH_MINERAL_IMPORT_MATCHED_OWNERS[SUCCESS],
  FETCH_MINERAL_IMPORT_MATCHED_OWNERS[ERROR]
);

export const fetchMineralImportNewProperties = makeApiActionCreatorV3(
  api.fetchMineralImportNewProperties,
  FETCH_MINERAL_IMPORT_NEW_PROPERTIES[START],
  FETCH_MINERAL_IMPORT_NEW_PROPERTIES[SUCCESS],
  FETCH_MINERAL_IMPORT_NEW_PROPERTIES[ERROR]
);

export const fetchMineralImportNewAgents = makeApiActionCreatorV3(
  api.fetchMineralImportNewAgents,
  FETCH_MINERAL_IMPORT_NEW_AGENTS[START],
  FETCH_MINERAL_IMPORT_NEW_AGENTS[SUCCESS],
  FETCH_MINERAL_IMPORT_NEW_AGENTS[ERROR]
);

export const fetchMineralImportNewOwners = makeApiActionCreatorV3(
  api.fetchMineralImportNewOwners,
  FETCH_MINERAL_IMPORT_NEW_OWNERS[START],
  FETCH_MINERAL_IMPORT_NEW_OWNERS[SUCCESS],
  FETCH_MINERAL_IMPORT_NEW_OWNERS[ERROR]
);

export const fetchMineralImportErrorProperties = makeApiActionCreatorV3(
  api.fetchMineralImportErrorProperties,
  FETCH_MINERAL_IMPORT_ERROR_PROPERTIES[START],
  FETCH_MINERAL_IMPORT_ERROR_PROPERTIES[SUCCESS],
  FETCH_MINERAL_IMPORT_ERROR_PROPERTIES[ERROR]
);

export const fetchMineralImportErrorAgents = makeApiActionCreatorV3(
  api.fetchMineralImportErrorAgents,
  FETCH_MINERAL_IMPORT_ERROR_AGENTS[START],
  FETCH_MINERAL_IMPORT_ERROR_AGENTS[SUCCESS],
  FETCH_MINERAL_IMPORT_ERROR_AGENTS[ERROR]
);

export const fetchMineralImportErrorOwners = makeApiActionCreatorV3(
  api.fetchMineralImportErrorOwners,
  FETCH_MINERAL_IMPORT_ERROR_OWNERS[START],
  FETCH_MINERAL_IMPORT_ERROR_OWNERS[SUCCESS],
  FETCH_MINERAL_IMPORT_ERROR_OWNERS[ERROR]
);

export const fetchMineralImportMineralDetails = makeApiActionCreatorV3(
  api.fetchMineralImportMineralDetails,
  FETCH_MINERAL_IMPORT_MINERAL_DETAILS[START],
  FETCH_MINERAL_IMPORT_MINERAL_DETAILS[SUCCESS],
  FETCH_MINERAL_IMPORT_MINERAL_DETAILS[ERROR]
);

export const fetchMineralImportDeletedDetails = makeApiActionCreatorV3(
  api.fetchMineralImportDeletedDetails,
  FETCH_MINERAL_IMPORT_DELETED_DETAILS[START],
  FETCH_MINERAL_IMPORT_DELETED_DETAILS[SUCCESS],
  FETCH_MINERAL_IMPORT_DELETED_DETAILS[ERROR]
);